/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { useEffect, useState } from "react";

export const useCookie = (name?: string): string | undefined => {
	const [cookieValue, setCookieValue] = useState<string | undefined>(undefined);

	const getCookieValue = (name: string): string | undefined => {
		let value = undefined;
		if (document) {
			const cookies = `; ${document.cookie}`;
			const parts = cookies.split(`; ${name}=`);
			if (parts.length === 2) {
				value = parts.pop()?.split(";").shift();
			}
		}
		return value;
	};

	useEffect(() => {
		if (name) {
			const cookieValue = getCookieValue(name);
			setCookieValue(cookieValue);
		}
	}, [name]);
	return cookieValue;
};
